import { Box, ButtonBase, Typography, useTheme } from "@mui/material";
import { Lock } from "lucide-react";
import type { FC, ReactNode } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { IconBox } from "web_myplann/Shared/Components/IconBox";

type Props = {
	label: string;
	icon: ReactNode;
	iconBg: string;
	isLocked?: boolean;
	onClick: () => void;
};

export const QuickCalculatorTile: FC<Props> = ({
	label,
	icon,
	iconBg,
	isLocked = false,
	onClick,
}) => {
	const { dashboard, palette } = useTheme();
	const { t } = useResource();
	const { tile, lockBadge } = dashboard.quickCalculator;

	return (
		<ButtonBase
			disableRipple
			onClick={onClick}
			sx={{
				flexShrink: 0,
				flexDirection: "column",
				justifyContent: "flex-start",
				width: tile.width,
				"&:active": { transform: tile.activeTransform },
			}}
		>
			<Box position="relative">
				<IconBox bg={iconBg} shape="circle" size={tile.circleSize}>
					{icon}
				</IconBox>
				{isLocked && (
					<IconBox
						bg={palette.grey[300]}
						shape="circle"
						size={lockBadge.size}
						position="absolute"
						bottom={0}
						right={0}
						border={`${lockBadge.borderWidth}px solid ${palette.surface.muted}`}
					>
						<Lock
							role="img"
							aria-label={t(Resources.Calculators.Unavailable.Tag)}
							size={lockBadge.iconSize}
							color={palette.grey[600]}
						/>
					</IconBox>
				)}
			</Box>
			<Typography
				variant="button"
				color={palette.grey[600]}
				display="block"
				pt={tile.labelGap}
				textAlign="center"
				lineHeight={tile.labelLineHeight}
			>
				{label}
			</Typography>
		</ButtonBase>
	);
};
